<template>
  <!-- 资金计划 -->
  <div class="table_container">
    <el-table
      ref="tableRef"
      highlight-current-row
      :border="true"
      :data="tableData"
      :header-cell-style="{
        background: '#EFEFEF',
        color: '#000',
        borderColor: '#dcdfe6'
      }"
      :cell-style="{ borderColor: '#dcdfe6' }"
      :cell-class-name="cellClassName"
      @cell-click="handleCellClick"
    >
      <!-- 序号 -->
      <el-table-column label="序号" width="50px" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <!-- 类别 -->
      <el-table-column
        prop="type"
        label="类别"
        min-width="170px"
        align="center"
        class-name="disabled_column"
      />
      <!-- 科目 -->
      <el-table-column
        prop="subject"
        label="科目"
        min-width="120px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'subject' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.subject"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.subject }}
          </div>
        </template>
      </el-table-column>
      <!-- 查询年 -->
      <el-table-column
        :label="`${Number(queryParams.years)}年批发/终端实销`"
        align="center"
      >
        <!-- 资金 -->
        <el-table-column
          v-for="(item, index) in monthList"
          :key="index"
          :prop="item.fundField"
          :label="item.month"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="
                !isTotalRow(scope.$index, item.totalRow) &&
                  editField === item.fundField &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row[item.fundField]"
              class="number_input"
              :controls="false"
              :precision="2"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <div v-else>
              {{ scope.row[item.fundField] }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- 备注 -->
      <el-table-column
        prop="remark"
        label="备注"
        min-width="120px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'remark' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.remark"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.remark }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { addOrUpdateFundPlanApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      queryParams: {},
      tableData: [], // 表格数据
      editField: "", // 编辑单元格
      editIndex: -1, // 编辑行索引
      monthList: [
        {
          month: "起初数据",
          fundField: "initData",
          totalRow: [5, 11] // 计算行索引
        },
        {
          month: "1月",
          fundField: "oneData",
          totalRow: [5, 11, 12, 13] // 计算行索引
        },
        {
          month: "2月",
          fundField: "twoData",
          totalRow: [5, 11, 12, 13] // 计算行索引
        },
        {
          month: "3月",
          fundField: "threeData",
          totalRow: [5, 11, 12, 13] // 计算行索引
        },
        {
          month: "4月",
          fundField: "fourData",
          totalRow: [5, 11, 12, 13] // 计算行索引
        },
        {
          month: "5月",
          fundField: "fiveData",
          totalRow: [5, 11, 12, 13] // 计算行索引
        },
        {
          month: "6月",
          fundField: "sixData",
          totalRow: [5, 11, 12, 13] // 计算行索引
        },
        {
          month: "7月",
          fundField: "sevenData",
          totalRow: [5, 11, 12, 13] // 计算行索引
        },
        {
          month: "8月",
          fundField: "eightData",
          totalRow: [5, 11, 12, 13] // 计算行索引
        },
        {
          month: "9月",
          fundField: "nineData",
          totalRow: [5, 11, 12, 13] // 计算行索引
        },
        {
          month: "10月",
          fundField: "tenData",
          totalRow: [5, 11, 12, 13] // 计算行索引
        },
        {
          month: "11月",
          fundField: "elevenData",
          totalRow: [5, 11, 12, 13] // 计算行索引
        },
        {
          month: "12月",
          fundField: "twelveData",
          totalRow: [5, 11, 12, 13] // 计算行索引
        },
        {
          month: "期末数据",
          fundField: "endData",
          totalRow: [5, 11, 12] // 计算行索引
        }
      ] // 月度
    };
  },
  methods: {
    init(data, queryParams = {}) {
      this.tableData = data || [];
      this.queryParams = { ...queryParams };
    },
    // 是否合计行
    isTotalRow(index, totalRow) {
      if (!totalRow) return false;
      return totalRow?.indexOf(index) !== -1;
    },
    // 获取单元格索引
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column = { ...column, index: columnIndex };
      if (
        this.isTotalRow(
          rowIndex,
          this.monthList.find(item => item.fundField === column.property)
            ?.totalRow
        )
      ) {
        return "total_column";
      }
    },
    // 点击单元格
    handleCellClick(row, column) {
      this.handleColumn(column.property, row.index ?? -1);
      this.tableData[row.index][column.property] =
        this.tableData[row.index][column.property] ?? undefined;
    },
    // 点击单元格编辑
    handleColumn(field, index) {
      this.editField = field;
      this.editIndex = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
      this.editIndex = -1;
    },
    // 保存
    async handleSave(callBack) {
      try {
        const submitData = {
          ...this.queryParams,
          dataList: JSON.parse(JSON.stringify(this.tableData))
        };
        const res = await addOrUpdateFundPlanApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.tableData = res.data || [];
          callBack();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
  ::v-deep {
    .disabled_column {
      background: #f2f2f2 !important;
    }
    .total_column,
    .el-table__footer-wrapper tbody td.el-table__cell {
      background: #c0cfde !important;
    }
  }
}
</style>
